import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';
import PropTypes from 'prop-types';
import question from '../../assets/icon-question.svg';
import styles from './styles.module.scss';


export const TooltipItem = ({
                              id,
                              placement = 'left',
                              triggerElement,
                              trigger = ['click'],
                              tooltipText = 'Fill the tooltipText prop!',
                              showArrow = false,
                              customTooltipStyles,
                              textDirection = 'rtl'
                            }) => {
  const commonTooltipStyles = {
    border: '1px solid #00a3ae',
    fontWeight: 700,
    color: '#6c6c6c',
    textAlign: 'end'
  };

  return (
    <Tooltip
      id={id}
      placement={placement}
      overlay={<span dir={textDirection}>{tooltipText}</span>}
      trigger={trigger}
      overlayClassName={styles.overlay}
      overlayInnerStyle={{...commonTooltipStyles, customTooltipStyles}}
      showArrow={showArrow}
    >
      {triggerElement
        ? triggerElement
        : <img src={question} alt="icon" className={styles.icon}/>
      }
    </Tooltip>
  );
};

TooltipItem.propTypes = {
  id: PropTypes.bool.isRequired,
  placement: PropTypes.string,
  triggerElement: PropTypes.node,
  trigger: PropTypes.array,
  tooltipText: PropTypes.node.isRequired,
  showArrow: PropTypes.bool,
  tooltipStyles: PropTypes.object,
  textDirection: PropTypes.string
};

export default TooltipItem;
